
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component:()=>import('../layout/default.vue'),
    redirect: '/events',
    meta: {
      requiresAuth: true,
      
    },
    children: [
      {
        path: '/events',
        name: 'events',
        component: () => import('../views/events/index.vue'),
        redirect: '/events/list/1',
        children: [
          {
            path: '/events/list/:id',
            name: 'events_list',
            component: () => import('../views/events/list.vue'),
          
          },

        ]
      },
      {
        path: '/reunion',
        name: 'reunion',
        component: () => import('../views/reunion/index.vue'),

        children: [
          {
            path: '/reunion/list',
            name: 'reunion_list',
            component: () => import('../views/reunion/list.vue')
          },
        
        ]
      },



    ]

  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/events/detail/',
    name: 'detail',
    //component:()=>import('../views/events/detail/index.vue'),
    component: () => import('@/layout/content.vue'),

    children: [
      {
        path: '/events/detail/form',
        name: 'detail_form',
        component: () => import('../views/events/detail/form.vue'),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: '/reunion/form',
        name: 'reunion_form',
        component: () => import('../views/events/detail/form.vue')
      },
    
      {
        path: '/events/detail/',
        name: 'detail_content',
        component: () => import('../views/events/detail/index.vue'),
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: '/events/detail/:id',
            name: 'detail_content',
            component: () => import('../views/events/detail/content.vue'),

          },
         
        ]
      },
      {
        path: '/mine',
        name: 'mine',
        component: () => import('../views/mine/index.vue'),
        redirect: '/mine/profile',
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: '/mine/profile',
            name: 'profile',
            component: () => import('../views/mine/profile.vue')
          },
          {
            path: '/mine/changepwd',
            name: 'changepwd',
            component: () => import('../views/mine/changepwd.vue')
          },
          {
            path: '/mine/events',
            name: 'myevents',
            component: () => import('../views/mine/my_events.vue')
          }
        ]
      },
      {
        path: '/resetpwd',
        name: 'resetpwd',
        component: () => import('../views/help/resetpwd/index.vue')
      },
      {
        path: '/agreement',

        name: 'agreement',
        component: () => import('../views/help/agreement/index.vue')
      },

      {
        path: '/help',
        name: 'help',
        component: () => import('../views/help/index.vue'),
        children: [
          {
            path: '/help/findpwd',

            name: 'findpwd',
            component: () => import('../views/help/findpwd.vue')

          },
          {
            path: '/help/findaccout',

            name: 'findaccout',
            component: () => import('../views/help/findaccout.vue')

          },
       
        ]
      }

   
    ]
  },



]

export default routes